import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { LarsAccessService } from 'src/app/ai-assistant/services/lars-access.service';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss']
})
export class NavMenuComponent implements OnInit {
  title = 'L&R Midland';
  isExpanded = false;
  isGuarded = false;
  isStaging = false;
  isDevelopment = false;

  public isAuthenticated: Observable<boolean>;
  public userName: Observable<string>;
  public role: Observable<string>;
  public larsEnabled: Observable<boolean>;

  constructor(
    private authorizeService: AuthorizeService,
    private larsAccess: LarsAccessService,
  ) { }

  ngOnInit(): void {
    this.isAuthenticated = this.authorizeService.isAuthenticated();
    this.userName = this.authorizeService.getUser().pipe(map(u => u && u.name));
    this.role = this.authorizeService.getUser().pipe(map(u => u && u.role));
    // Show the LARS menu only when the current user has "Enable LARS" (live server check).
    this.larsEnabled = this.isAuthenticated.pipe(
      switchMap(auth => auth ? this.larsAccess.isEnabled$() : of(false)));
    this.isStaging = window.location.hostname.includes('-stage')
    this.isDevelopment = window.location.hostname.includes('localhost');
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

}
